import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RxCross1 } from "react-icons/rx";
import { HiPlus, HiOutlineMinus } from "react-icons/hi";
import { IoBagHandleOutline } from "react-icons/io5";
import { addTocart, removeFromCart } from "../../redux/actions/cart";
import "./Cart.scss";

const Cart = ({ setOpenCart }) => {
  const dispatch = useDispatch();
  const { cart } = useSelector((state) => state.cart);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const totalPrice = cart.reduce((acc, item) => {
    const priceForOne = item.discountPrice ?? item.originalPrice ?? 0;
    return acc + item.qty * priceForOne;
  }, 0);

  const handleOverlayClick = () => {
    setOpenCart(false);
  };

  const handleModalClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div className="centered-cart-overlay" onClick={handleOverlayClick}>
      <div className="centered-cart-container" onClick={handleModalClick}>
        <button
          className="centered-cart-close-btn"
          onClick={() => setOpenCart(false)}
        >
          <RxCross1 size={20} />
        </button>

        <div className="centered-cart-header">
          <IoBagHandleOutline size={20} />
          <h2>Моя корзина</h2>
        </div>

        {cart.length === 0 ? (
          <div className="centered-cart-empty">
            <h3>Корзина пуста</h3>
            <p>Добавте товари, поки що тут пусто :(</p>
          </div>
        ) : (
          <>
            <div className="centered-cart-items">
              {cart.map((item, index) => (
                <CartItem key={index} itemData={item} dispatch={dispatch} />
              ))}
            </div>

            <div className="centered-cart-footer">
              <div className="centered-cart-total">
                <span>Загалом:</span>
                <b>{(totalPrice || 0 ).toLocaleString("uk-UA")} грн</b>
              </div>
              <Link to="/checkout">
                <button className="centered-cart-checkout-btn">
                  Оформити замовлення
                </button>
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const CartItem = ({ itemData, dispatch }) => {
  const [qty, setQty] = useState(itemData.qty);
  const priceForOne = itemData.discountPrice ?? itemData.originalPrice ?? 0;
  const totalItemPrice = priceForOne * qty;

  const increment = () => {
    const newQty = qty + 1;
    setQty(newQty);
    dispatch(addTocart({ ...itemData, qty: newQty }));
  };

  const decrement = () => {
    if (qty > 1) {
      const newQty = qty - 1;
      setQty(newQty);
      dispatch(addTocart({ ...itemData, qty: newQty }));
    }
  };

  const removeItem = () => {
    dispatch(removeFromCart(itemData));
  };

  return (
    <div className="centered-cart-item">
      <div className="centered-cart-item-image">
        <img
          src={itemData.images?.[0]?.url || "/placeholder-image.jpg"}
          alt={itemData.name}
        />
      </div>

      <div className="centered-cart-item-info">
        <h4>{itemData.name}</h4>

        <p className="centered-cart-item-price">
          {itemData.discountPrice ? (
            <>
              {itemData.originalPrice && itemData.originalPrice !== itemData.discountPrice && (
                <del style={{ marginRight: "8px" }}>{itemData.originalPrice} грн</del>
              )}
              <span>{(itemData.discountPrice || 0).toLocaleString("uk-UA")} грн</span>
              <br />
              <span>
                x {qty} = {(totalItemPrice || 0).toLocaleString("uk-UA")} грн
              </span>
            </>
          ) : (
            <>
              {(itemData.originalPrice || 0).toLocaleString("uk-UA")} грн
              <br />
              x {qty} = {(totalItemPrice || 0).toLocaleString("uk-UA")} грн
            </>
          )}
        </p>

        <div className="centered-cart-item-controls">
          <button onClick={decrement}>
            <HiOutlineMinus size={18} />
          </button>
          <span>{qty}</span>
          <button onClick={increment}>
            <HiPlus size={18} />
          </button>
        </div>
      </div>

      <button className="centered-cart-item-remove" onClick={removeItem}>
        <RxCross1 size={16} />
      </button>
    </div>
  );
};

export default Cart;
